/* TOPページカルーセルスライダー（20260704設置） */
$(document).ready(function(){
  $('.product-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    arrows: true,
    centerMode: true,
    centerPadding: "5%",
    responsive: [{
        breakpoint: 767,
        settings: {
          dots: true,
          vertical: true,
          verticalSwiping: true,
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
    }]
  });
});

/* スクロールに応じて出現するバナー（20260705設置）
$(window).on('scroll', function() {
  if ($(this).scrollTop() > 300) {
    $('.floating-menu').addClass('is-active');
  } else {
    $('.floating-menu').removeClass('is-active');
  }
}); */

/* スクロールに応じて出現するバナー（page-wrapper完全対応版） */
document.addEventListener('DOMContentLoaded', function() {
  const floatingMenu = document.querySelector('.floating-menu');
  if (!floatingMenu) return;

  function updateBannerVisibility(e) {
    let scrollTop = 0;

    // スクロールを発生させている要素（e.target）から直接スクロール量を取得
    if (e && e.target && e.target !== document && e.target !== window) {
      scrollTop = e.target.scrollTop || 0;
    } else {
      // 初期読み込み時などは page-wrapper または window から取得
      const pageWrapper = document.querySelector('.page-wrapper');
      scrollTop = Math.max(
        window.pageYOffset || 0,
        document.documentElement.scrollTop || 0,
        document.body.scrollTop || 0,
        pageWrapper ? pageWrapper.scrollTop : 0
      );
    }

    // 300px以上スクロールしたかでクラスを着脱
    if (scrollTop > 300) {
      floatingMenu.classList.add('is-active');
    } else {
      floatingMenu.classList.remove('is-active');
    }
  }

  // キャプチャフェーズ（第3引数: true）で内部要素のスクロールイベントを確実にキャッチ
  window.addEventListener('scroll', updateBannerVisibility, true);

  // リサイズ時と初期表示時にも判定を実行
  window.addEventListener('resize', updateBannerVisibility);
  updateBannerVisibility();
});



// イベント委譲を使ってボタンクリックを監視
document.addEventListener('click', async (e) => {
  
  // 対象のボタン判定（PDF発行ボタン または チェックアウトボタン）
  const pdfBtn = e.target.closest('#pdf_Quotation');
  const checkoutBtn = e.target.closest('div.cart-drawer__inner button[name="checkout"].cart__checkout-button'); // テーマのチェックアウトボタンのセレクターに合わせて調整

  if (!pdfBtn && !checkoutBtn) return;

  // submit処理をストップする
  e.preventDefault();
  e.stopPropagation();

  // カート内の入力チェック
  const isValid = await validateCartContents();

  if (!isValid) {
    return;
  }

  // ボタン処理の実行
  if (checkoutBtn) {
    // ボタンの form 属性からフォームを取得
    const formId = checkoutBtn.getAttribute('form');
    const form = formId ? document.getElementById(formId) : document.querySelector('form.cart-form');
    // 次のカート処理に遷移
    if (form) form.submit();

  } else if (pdfBtn) {
    // 見積書PDFを発行
    generateCustomQuote();

  }

});

/**
 * カート内の入力チェック
 * @returns エラーがなければ true、エラーがあれば false
 */
async function validateCartContents() {

  const errorMessageEl = document.getElementById('cart-error-message');
  
  try {
    // カート情報を取得
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await response.json();

    // 外径・内径の入力チェック
    let hasInvalidDimensions = false;

    cart.items.forEach(item => {
      const props = item.properties || {};

      // 外径・内径を取得（和名・英名両対応）
      const outerRaw = props['外径'];
      const innerRaw = props['内径'];

      if (outerRaw && innerRaw) {
        const outerDiameter = parseFloat(outerRaw);
        const innerDiameter = parseFloat(innerRaw);

        // 外径が内径+1mm未満の場合エラー
        if (!isNaN(outerDiameter) && !isNaN(innerDiameter) && outerDiameter < innerDiameter + 1) {
          hasInvalidDimensions = true;
        }
      }
    });

    if (hasInvalidDimensions) {
      errorMessageEl.textContent = '外径は内径より1mm以上大きい値を入力してください。';
      if (errorMessageEl) errorMessageEl.style.display = 'block';
      return false; // NG
    }

    // エラーがなければ非表示
    if (errorMessageEl) errorMessageEl.style.display = 'none';
    return true; // OK

  } catch (error) {
    console.error('カートの確認中にエラーが発生しました:', error);
    return true;
  }
}

/**
 * カート情報をもとに見積書PDFを生成・ダウンロードする
 */
async function generateCustomQuote() {

  const response = await fetch(window.Shopify.routes.root + 'cart.js');
  const cart = await response.json();

  if (cart.item_count === 0) {
    alert("カートが空です");
    return;
  }

  // 一時描画用コンテナの作成（空白出力バグ防止）
  const quoteWrapper = document.createElement('div');
  quoteWrapper.style.position = 'fixed';
  quoteWrapper.style.left = '-9999px';
  quoteWrapper.style.top = '0';
  document.documentElement.appendChild(quoteWrapper);

  const quoteElement = document.createElement('div');
  quoteElement.style.width = '794px'; // A4幅固定
  quoteElement.style.padding = '50px';
  quoteElement.style.backgroundColor = '#fff';
  quoteElement.style.fontFamily = 'sans-serif';
  quoteElement.style.color = '#000';
  quoteWrapper.appendChild(quoteElement);

  // 明細（商品名・仕様プロパティ・単価・数量・小計）の構築
  let itemsHtml = '';
  cart.items.forEach(item => {
    let propertiesHtml = '';
    let customQty = '';
    if (item.properties) {

      // propertiesから「数量」の値を取得
      customQty = item.properties['数量'] ;
      // 商品オプションのhtmlを生成
      Object.entries(item.properties).forEach(([key, value]) => {
        console.log(key + '' + value);
        if (!key.startsWith('_') && key !== '数量') {
          propertiesHtml += `<div style="font-size: 11px; color: #555; margin-left: 5px;">・${key}: ${value}</div>`;
        }
      });
    }

    itemsHtml += `
      <tr style="border-bottom: 1px solid #eee;">
        <td style="padding: 10px 5px; vertical-align: top;">
          <div style="font-weight: bold; font-size: 13px;">${item.product_title}</div>
          ${item.variant_title ? `<div style="font-size: 11px; color: #333;">${item.variant_title}</div>` : ''}
          ${propertiesHtml}
        </td>
        <td style="padding: 10px 5px; text-align: center; vertical-align: top; font-size: 13px;">${customQty}</td>
        <td style="padding: 10px 5px; text-align: right; vertical-align: top; font-size: 13px;">¥${customQty ? Math.floor(item.final_line_price / 100 / Number(customQty)).toLocaleString() : (item.final_line_price / 100).toLocaleString()}</td>
        <td style="padding: 10px 5px; text-align: right; vertical-align: top; font-size: 13px; font-weight: bold;">¥${(item.final_line_price / 100).toLocaleString()}</td>
      </tr>
    `;
  });

  // レイアウト全景
  quoteElement.innerHTML = `
    <div style="margin-bottom: 30px;">
      <div style="text-align: right; font-size: 12px; line-height: 1.5;">
        <div>発行日: ${new Date().toLocaleDateString('ja-JP')}</div>
      </div>
      <h1 style="text-align: center;font-size: 26px; margin: 0; letter-spacing: 2px;">御見積書</h1>
    </div>
    
    <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 35px;">
      <!-- 左側：挨拶文と件名 -->
      <div style="width: 55%;">
        <div style="font-size: 11px; margin-bottom: 12px;">下記の通り、お見積もり申し上げます。</div>
        <div style="border-bottom: 1px solid #000; padding-bottom: 5px;">
          <span style="font-size: 16px; font-weight: bold;">件名：円筒カラー部品</span>
        </div>
      </div>

      <!-- 右側：会社情報 -->
      <div>
        <img src="https://urukara.myshopify.com/cdn/shop/files/logo.png" style="height: 30px;" alt="ウルカラロゴ">
        <div>カラー専用販売サイトＵＲＵＫＡＲＡ</div>
        <adress><div>490-1107</div><div>愛知県あま市森1丁目2-15</div></adress>
        <div>株式会社三喜工作所</div>
        <div>インボイス：T6180001097888</div>
      </div>
    </div>

    <table style="width: 100%; border-collapse: collapse; margin-bottom: 25px; table-layout: fixed;">
      <thead>
        <tr style="background: #333; color: #fff;">
          <th style="padding: 8px; text-align: left; font-size: 12px; width: 55%;">商品名 / 仕様</th>
          <th style="padding: 8px; text-align: center; font-size: 12px; width: 10%;">数量</th>
          <th style="padding: 8px; text-align: right; font-size: 12px; width: 15%;">単価</th>
          <th style="padding: 8px; text-align: right; font-size: 12px; width: 20%;">金額</th>
        </tr>
      </thead>
      <tbody>
        ${itemsHtml}
      </tbody>
    </table>
    <div>※寸法公差±0.1mmとなります。</div>
    <div style="display: flex; justify-content: flex-end;">
      <div style="width: 220px; font-size: 15px; font-weight: bold; border-bottom: 2px solid #000; padding: 5px 0; display: flex; justify-content: space-between;">
        <span>合計金額(税込)</span>
        <span>¥${(cart.total_price / 100).toLocaleString()}</span>
      </div>
    </div>
  `;

  // PDF書き出し設定
  const datetime = new Date().toLocaleString('sv-SE', { timeZone: 'Asia/Tokyo' }).replace(/[- :]/g, '');
  const opt = {
    margin: 0,
    filename: `URUKARA_御見積書_${datetime}.pdf`,
    html2canvas: { scale: 2, useCORS: true, width: 794, scrollY: 0,
      // カスタムエレメント（Web Components）をキャンバス化の対象から無視するオプション
      ignoreElements: (element) => element.tagName.includes('-')
     },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  try {
    await html2pdf().set(opt).from(quoteElement).save();
  } catch (err) {
    console.error("PDF作成エラー:", err);
  } finally {
    // 追加した要素の削除
    if (quoteWrapper.parentNode) {
      quoteWrapper.parentNode.removeChild(quoteWrapper);
    }
  }
}
